// src/utils/portataCaviUtils.js
// Unico posto dove vive la tabella di portata cavi CEI-UNEL 35024/1 (nomenclatura IEC
// 364-5-523: metodi A, A2, B, B2, C, E) e il fattore di correzione temperatura K1 — riusata
// da "Sezione cavo", "Coordinamento interruttore-cavo" e dalle verifiche automatiche di
// "Ordine Cavi", così i tre non possono mai calcolare numeri diversi per lo stesso cavo.
//
// Valori riportati da un documento tecnico ufficiale (archivio pubblico governativo,
// "Parametri di calcolo e di verifica" — tabelle 11 e 6, cavi multipolari, conduttori in
// rame, temperatura di riferimento 30°C) che riproduce le tabelle IEC 364-5-523 / CEI-UNEL
// 35024/1 — non una stima a memoria. Coperti solo i metodi con dati completi sulla maggior
// parte delle sezioni commerciali; il metodo D (posa interrata) non è incluso: dipende da
// resistività del terreno e profondità, parametri che nessuno strumento qui gestisce.
export const SEZIONI_DISPONIBILI = ["1.5","2.5","4","6","10","16","25","35","50","70","95","120","150","185","240"];

function tabella(valori2, valori3) {
  const out = {};
  SEZIONI_DISPONIBILI.forEach((s,i) => { out[s] = { 2: valori2[i] ?? null, 3: valori3[i] ?? null }; });
  return out;
}

export const METODI_POSA = {
  a:  { label: "Tubo incassato in parete isolante (A)",
        pvc:  tabella([14.5,19.5,26,34,46,61,80,99,119,151,182,210,240,273,320], [13.5,18,24,31,42,56,73,89,108,136,164,188,216,245,286]),
        xlpe: tabella([19,26,35,45,61,81,106,131,158,200,241,278,318,362,424],   [17,23,31,40,54,73,95,117,141,179,216,249,285,324,380]) },
  a2: { label: "Cavo multipolare in tubo incassato (A2)",
        pvc:  tabella([14,18.5,25,32,43,57,75,92,110,139,167,192,219,248,291],   [13,17.5,23,29,39,52,68,83,99,125,150,172,196,223,261]),
        xlpe: tabella([18.5,25,33,42,57,76,99,121,145,183,220,253,290,329,386],  [16.5,22,30,38,51,68,89,109,130,164,197,227,259,295,346]) },
  b:  { label: "Tubo protettivo a vista su parete (B)",
        pvc:  tabella([17.5,24,32,41,57,76,101,125,151,192,232,269,null,null,null], [15.5,21,28,36,50,68,89,110,134,171,207,239,null,null,null]),
        xlpe: tabella([23,31,42,54,75,100,133,164,198,253,306,354,null,null,null],  [20,28,37,48,66,86,117,144,175,222,269,312,null,null,null]) },
  b2: { label: "Più cavi multipolari in tubo a parete (B2)",
        pvc:  tabella([16.5,23,30,38,52,69,90,111,135,168,201,232,null,null,null], [15,20,27,34,46,62,80,99,118,149,176,206,null,null,null]),
        xlpe: tabella([22,30,40,51,69,91,119,146,175,221,265,305,null,null,null],  [19.5,26,35,44,60,80,105,128,154,194,233,268,null,null,null]) },
  c:  { label: "Cavo a parete/soffitto o su passerella (C)",
        pvc:  tabella([19.5,27,36,46,63,85,112,138,168,213,258,299,344,392,461],  [17.5,24,32,41,57,76,96,119,144,184,223,259,299,341,403]),
        xlpe: tabella([24,35,45,58,80,107,138,171,209,269,328,382,441,506,599],   [22,30,40,52,71,96,119,147,179,229,278,322,371,424,500]) },
  e:  { label: "Cavo in aria libera, distanziato (E)",
        pvc:  tabella([22,30,40,51,70,94,119,148,180,232,282,328,379,434,514],    [18.5,25,34,43,60,80,101,126,153,196,238,276,319,364,430]),
        xlpe: tabella([26,36,49,63,86,115,149,185,225,289,352,410,473,542,641],   [23,32,42,54,75,100,127,158,192,246,298,346,399,456,538]) },
};

// Compatibilità con codice che si aspetta la tabella "B1" con questo nome — è il metodo B,
// il più comune nella pratica (tubo a parete/incasso), tenuto come scorciatoia.
export const PORTATA_B1_PVC_RAME = METODI_POSA.b.pvc;

// Fattore di correzione temperatura K1 (riferimento 30°C = 1,00) — stessa fonte del punto sopra.
export const K1_PVC = { 10:1.22, 15:1.17, 20:1.12, 25:1.06, 30:1.00, 35:0.94, 40:0.87, 45:0.79, 50:0.71, 55:0.61, 60:0.50 };
export const K1_XLPE = { 10:1.15, 15:1.12, 20:1.08, 25:1.04, 30:1.00, 35:0.96, 40:0.91, 45:0.87, 50:0.82, 55:0.76, 60:0.71, 65:0.65, 70:0.58 };
export const TEMPERATURE_DISPONIBILI = Object.keys(K1_PVC).map(Number);

// Resistività a 20°C, valori di riferimento comunemente usati nella pratica elettrotecnica
// italiana — stessi usati dallo strumento "Caduta di Tensione".
export const RESISTIVITA_RAME = 0.0178;

// Legge una "Formazione" scritta in modo semplice (es. "3x2,5", "2x1.5") ed estrae la sezione
// in mm² — SOLO se il formato è semplice e riconoscibile; qualunque cosa di più complesso
// (notazioni con più conduttori di sezione diversa) resta fuori, senza indovinare nulla.
export function estraiSezioneDaFormazione(formazione) {
  const m = String(formazione||"").match(/^\s*(\d+)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(?:mm²?)?\s*$/i);
  if (!m) return null;
  return { conduttori: parseInt(m[1],10), sezione: m[2].replace(",",".") };
}

// Legge un "Interruttore" scritto in modo libero (es. "16A", "C16", "32", "C 25 A") ed
// estrae il primo numero come corrente nominale In — solo se c'è un numero riconoscibile.
export function estraiCorrenteDaInterruttore(testo) {
  const m = String(testo||"").match(/(\d+(?:[.,]\d+)?)/);
  return m ? parseFloat(m[1].replace(",",".")) : null;
}

// Determina "b" (2 monofase, √3 trifase) e il numero di conduttori caricati dalla tensione
// scritta in tabella — solo per i valori più comuni, altrimenti non si esprime.
export function tipoDaTensione(tensione) {
  const t = parseFloat(String(tensione||"").replace(",","."));
  if (t === 230 || t === 220) return { b: 2, nConduttori: 2, label: "monofase" };
  if (t === 400 || t === 380) return { b: Math.sqrt(3), nConduttori: 3, label: "trifase" };
  return null;
}
